import React from 'react';

export default function ChapterPickerModal({ assignments, assignmentSections, sectionState, toggleSection, onHourChange, onClose }) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>나의 담당과목 및 단원</h3>
          <button className="btn-primary btn-inline" onClick={onClose}>챕터선정</button>
        </div>

        <div className="modal-body">
          {assignments.map((a) => {
            const sections = assignmentSections[a.asnid] || [];
            return (
              <div key={a.asnid} className="chapter-block">
                <div className="chapter-block-title">[{a.subject}] {a.chapter}</div>
                <div className="section-list">
                  <label className="field-label">세부교육 내용 (표준교재 섹션) - 선택 후 학과/실습 시간 입력</label>
                  {sections.map((s) => {
                    const state = sectionState[s.crssectno] || {};
                    return (
                      <div key={s.crssectno} className="section-item">
                        <div className="section-item-row">
                          <label className="section-check">
                            <input
                              type="checkbox"
                              checked={!!state.checked}
                              onChange={() => toggleSection(s.crssectno)}
                            />
                            {s.sections}
                          </label>
                          {state.checked && (
                            <div className="section-hour-group">
                              <div className="chapter-hour-input-wrap">
                                학과
                                <input
                                  type="number"
                                  min="0"
                                  value={state.thrytime ?? 0}
                                  onChange={(e) => onHourChange(s.crssectno, 'thrytime', e.target.value)}
                                />
                              </div>
                              <div className="chapter-hour-input-wrap">
                                실습
                                <input
                                  type="number"
                                  min="0"
                                  value={state.practime ?? 0}
                                  onChange={(e) => onHourChange(s.crssectno, 'practime', e.target.value)}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                  {sections.length === 0 && <div className="empty-hint">등록된 섹션 없음</div>}
                </div>
              </div>
            );
          })}
          {assignments.length === 0 && <div className="empty-hint">배정받은 챕터가 없습니다.</div>}
        </div>
      </div>
    </div>
  );
}
